<template>
    <div>
        <v-dialog v-model="show_dialog" ref="save_registration_dialog" scrollable persistent max-width="600px" :fullscreen="$vuetify.breakpoint.smAndDown">
            <v-form ref="saveRegistrationForm" method="post" :action="form.action" v-model="form.valid" v-on:success="save_success" v-on:warning="warning_callback">
                <v-card>
                    <v-card-title
                            class="headline blue darken-2 white--text"
                            primary-title
                    >
                        <div v-if="form.data.registration_id > 0">{{$t('registration.edit_registration')}}</div>
                        <div v-else>{{$t('registration.create_registration')}}</div>
                    </v-card-title>
                    <v-card-text class="v-dialog-body">
                        <input type="hidden" name="event_id" v-model="event_item.id">
                        <input type="hidden" name="activity" v-model="form.data.activity">
                        <input type="hidden" name="attend_status" v-model="form.data.attend_status">
                        <input type="hidden" name="registration_id" v-model="form.data.registration_id">
                        <input type="hidden" name="registrant_name" v-model="form.data.registrant_name">
                        <input type="hidden" name="registrant_phone" v-model="form.data.registrant_phone">
                        <input type="hidden" name="confirm_possible_duplicate_registration" v-model="form.data.confirm_possible_duplicate_registration">

                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex xs12 v-if="form.errors.general!==''">
                                    <v-alert
                                            :value="form.errors.general!==''"
                                            type="error"
                                    >
                                        {{form.errors.general}}
                                    </v-alert>
                                </v-flex>

                                <v-flex xs12 v-if="event_item.ask_for_attend">
                                    <v-btn-toggle v-model="form.data.attend_status" mandatory >
                                        <v-btn :value="1" color="success" class="white--text">{{$t('action.attend')}}</v-btn>
                                        <v-btn :value="7" color="primary" class="white--text">{{$t('action.maybe')}}</v-btn>
                                        <v-btn :value="8" color="error" class="white--text">{{$t('action.excuse')}}</v-btn>
                                    </v-btn-toggle>
                                </v-flex>

                                <v-flex xs12 v-if="event_item.enable_select_name_from_invitations && event_item.contact_select_list.length">
                                    <v-autocomplete
                                            :items="event_item.contact_select_list"
                                            v-model="selected_contact_info"
                                            :label="$t('registration.select_name_from_list')"
                                            item-text="search_field"
                                            item-value="phone"
                                            clearable
                                            return-object
                                    >
                                        <template slot="selection" slot-scope="data">
                                            <v-list-tile-content>
                                                <v-list-tile-title v-text="data.item.name + ' (' + data.item.areaCode + ' ' + data.item.phone + ')'"></v-list-tile-title>
                                            </v-list-tile-content>
                                        </template>
                                        <template slot="item" slot-scope="data">
                                            <template>
                                                <v-list-tile-content>
                                                    <v-list-tile-title v-text="data.item.name"></v-list-tile-title>
                                                    <v-list-tile-sub-title v-text="data.item.areaCode + ' ' + data.item.phone"></v-list-tile-sub-title>
                                                </v-list-tile-content>
                                            </template>
                                        </template>
                                    </v-autocomplete>
                                </v-flex>
                            </v-layout>
                            <v-layout wrap v-show="!selected_contact_info">
                                <v-flex xs12 sm6>
                                    <v-text-field
                                            ref="registration_contact_name"
                                            :label="$t('registration.contact_name')"
                                            v-model="form.data.registrant_name"
                                            :rules="[rules.required]"
                                            :error-messages="form.errors.registrant_name"
                                            append-icon="search"
                                            @click:append="showSearchContactDialog(form.data.registrant_name)"
                                            @keypress.13.prevent
                                            @keypress.13="showSearchContactDialog(form.data.registrant_name)"
                                            name="registrant_name"
                                    >
                                    </v-text-field>
                                </v-flex>

                                <v-flex xs4 sm2>
                                    <v-text-field
                                            :label="$t('contact.area_code')"
                                            v-model="form.data.registrant_area_code"
                                            :rules="[rules.required]"
                                            :error-messages="form.errors.registrant_area_code"
                                            prefix="+"
                                            name="registrant_area_code"
                                            mask="###"
                                    >
                                    </v-text-field>
                                </v-flex>

                                <v-flex xs8 sm4>
                                    <v-text-field
                                            :label="$t('registration.contact_phone')"
                                            v-model="form.data.registrant_phone"
                                            :rules="[rules.required]"
                                            :error-messages="form.errors.registrant_phone"
                                            append-icon="search"
                                            @click:append="showSearchContactDialog(form.data.registrant_phone)"
                                            @keypress.13.prevent
                                            @keypress.13="showSearchContactDialog(form.data.registrant_phone)"
                                            name="registrant_phone"
                                            :mask="phoneMask"
                                    >
                                    </v-text-field>
                                </v-flex>
                            </v-layout>

                            <v-layout wrap>
                                <v-flex xs12 v-if="event_item.enable_custom_field">
                                    <v-text-field
                                            :label="event_item.custom_field_label"
                                            v-model="form.data.custom_field_value"
                                            name="custom_field_value"
                                    >
                                    </v-text-field>
                                </v-flex>

                                <v-flex xs12 v-if="event_item.enable_custom_field_2">
                                    <v-text-field
                                            :label="event_item.custom_field_label_2"
                                            v-model="form.data.custom_field_value_2"
                                            name="custom_field_value_2"
                                    >
                                    </v-text-field>
                                </v-flex>

                                <v-flex xs12 v-if="event_item.enable_custom_field_3">
                                    <v-text-field
                                            :label="event_item.custom_field_label_3"
                                            v-model="form.data.custom_field_value_3"
                                            name="custom_field_value_3"
                                    >
                                    </v-text-field>
                                </v-flex>

                                <v-flex sm12 v-if="hasActivity && form.data.attend_status == 1">
                                    <p>{{$t('registration.select_an_activity')}}</p>

                                    <div v-if="event_item.activity_multiple">
                                        <v-input :error-messages="form.errors.activity">
                                            <template v-for="(activity_item) in event_item.activities">
                                                <v-checkbox
                                                        v-model="form.data.activity"
                                                        class="mt-0 mb-3"
                                                        color="indigo"
                                                        :label="activity_item.name"
                                                        :value="activity_item.id"
                                                        hide-details
                                                ></v-checkbox>
                                            </template>
                                        </v-input>
                                    </div>

                                    <v-radio-group
                                            v-else
                                            v-model="form.data.activity[0]"
                                            :error-messages="form.errors.activity"
                                            row
                                    >
                                        <template v-for="(activity_item) in event_item.activities">
                                            <v-radio :label="activity_item.name" :value="activity_item.id" color="primary"></v-radio>
                                        </template>
                                    </v-radio-group>
                                </v-flex>

                                <v-flex xs12 sm6 v-if="showGuestSection">
                                    <v-select
                                            :items="getGuestNumberItems"
                                            :label="$t('registration.total_guest_number')"
                                            :error-messages="form.errors.total_guest_number"
                                            v-model="form.data.total_guest_number"
                                    ></v-select>
                                    <input type="hidden" name="total_guest_number" :value="form.data.total_guest_number">
                                </v-flex>

                                <v-flex xs12 v-show="form.data.registration_id <= 0 && showGuestSection">
                                    <v-checkbox
                                            v-model="form.data.is_attendee"
                                            name="is_attendee"
                                            class="mt-0 mb-3"
                                            color="indigo"
                                            :label="$t('registration.part_of_attendee')"
                                            value="1"
                                            hide-details
                                    ></v-checkbox>
                                </v-flex>

                                <v-flex xs12 v-if="showGuestSection">
                                    <h2 class="">
                                        {{$t('registration.guest_details')}}
                                    </h2>
                                </v-flex>

                                <template v-for="(n, index) in form.data.total_guest_number" v-if="showGuestSection">
                                    <v-flex xs12 sm6>
                                        <v-text-field
                                                v-model="form.data.guest_names[index]"
                                                :label="$t('registration.guest_name')"
                                                :name="'guest_names[' + index + ']'"
                                                :disabled="Boolean(form.data.is_attendee && index === 0)"
                                                append-icon="search"
                                                @click:append="showSearchContactDialog(form.data.guest_names[index], true, index)"
                                                @keypress.13.prevent
                                                @keypress.13="showSearchContactDialog(form.data.guest_names[index], true, index)"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs4 sm2>
                                        <v-text-field
                                                prefix="+"
                                                v-model="form.data.guest_area_codes[index]"
                                                :label="$t('contact.area_code')"
                                                :name="'guest_area_codes[' + index + ']'"
                                                :disabled="Boolean(form.data.is_attendee && index === 0)"
                                                mask="###"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs8 sm4>
                                        <v-text-field
                                                v-model="form.data.guest_phones[index]"
                                                :label="$t('registration.contact_phone')"
                                                :name="'guest_phones[' + index + ']'"
                                                :disabled="Boolean(form.data.is_attendee && index === 0)"
                                                append-icon="search"
                                                @click:append="showSearchContactDialog(form.data.guest_phones[index], true, index)"
                                                @keypress.13.prevent
                                                @keypress.13="showSearchContactDialog(form.data.guest_phones[index], true, index)"
                                                :mask="phoneMask"
                                        ></v-text-field>
                                    </v-flex>
                                </template>



                            </v-layout>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="grey" flat @click="closeDialog">{{$t('action.close')}}</v-btn>
                        <v-btn color="blue darken-1" flat type="submit" :loading="form.loading">{{$t('action.save')}}</v-btn>
                    </v-card-actions>

                </v-card>
            </v-form>
        </v-dialog>

        <contact-picker
          v-model="contactPicker.show"
          :default-search-string="contactPicker.defaultSearchString"
          :multipleSelect="false"
          @success="getContact"
        >

        </contact-picker>
    </div>
</template>

<script>
    import ContactPicker from '~/components/contact/ContactPicker'
    import FormHandling from "~/utils/data/form-handling";
    import {UrlServices} from "~/utils/url-manager";
    import RegistrationStatus from "~/components/enum/registration/RegistrationStatus.ts";

    export default {
        name: "SaveRegistrationDialog",
        components: {
            ContactPicker
        },
        props: {
            event_item: Object,
            show_dialog: Boolean,
            save_success_callback: Function,
            registration_item: Object
        },
        data() {
            return {
                activity_name_list: {},
                save_success: function() {},
                warning_callback: function() {},
                contactPicker: {
                    show: false,
                    defaultSearchString: "",
                    is_attendee: false,
                    attendee_index: 0
                },
                form: {
                    form_handling_object: null,
                    action: UrlServices.createUrl({name: "api_registration_save"}),
                    loading: false,
                    valid: false,
                    data: {
                        registration_id: 0,
                        custom_field_value: "",
                        custom_field_value_2: "",
                        custom_field_value_3: "",
                        registrant_name: "",
                        registrant_phone: "",
                        registrant_area_code: "852",
                        total_guest_number: 1,
                        attendees: [],
                        is_attendee: "1",
                        activity: [],
                        attend_status: 1,
                        guest_ids: [],
                        guest_names: [''],
                        guest_phones: [''],
                        guest_area_codes: [''],
                        confirm_possible_duplicate_registration: 0
                    },
                    errors: {
                        general: "",
                        registrant_name: "",
                        registrant_phone: "",
                        total_guest_number: "",
                        activity: ""
                    }
                },
                rules: {
                    required: value => (!!value) || this.$t('form.field_required')
                },
                phoneMask: '#'.repeat(50),
                selected_contact_info: null,
            };
        },
        computed: {
            getGuestNumberItems() {

                let items = _.range(1,100);
                if(this.event_item.has_quota_limit){
                    let remain_quota = parseInt(this.event_item.remain_quota);
                    if(this.registration_item){
                        remain_quota += parseInt(this.registration_item.attendee_count);
                    }

                    if(remain_quota){
                        let max = remain_quota + 1;
                        if(max >= 100){
                            max = 100;
                        }
                        items = _.range(1, max);
                    } else {
                        items = [];
                    }
                }
                return items;
            },
            hasActivity() {
                if(this.event_item.activities){
                    return !!this.event_item.activities.length;
                }else{
                    return false;
                }
            },
            showGuestSection() {
                let is_show = this.event_item.allow_guest_to_join;
                if(this.event_item.ask_for_attend){
                    is_show = (is_show && this.form.data.attend_status == 1);
                }
                return is_show;
            }
        },
        methods: {
            async closeDialog() {
                this.$emit('update:show_dialog', false);
                await this.$nextTick();     // Delay the following code so that bindings happen after the form is cleared
                this.form.form_handling_object.formReset();
                await this.$nextTick();
                this.form.data = {
                    activity: [],
                    registration_id: 0,
                    custom_field_value: "",
                    custom_field_value_2: "",
                    custom_field_value_3: "",
                    registrant_name: "",
                    registrant_phone: "",
                    registrant_area_code: "852",
                    total_guest_number: 1,
                    attendees: [],
                    is_attendee: "1",
                    guest_ids: [],
                    guest_names: [''],
                    guest_phones: [''],
                    guest_area_codes: ['852'],
                    confirm_possible_duplicate_registration: 0
                };
            },
            copyContactToFirstGuest() {
                if(this.form.data.is_attendee){
                    this.form.data.guest_names[0] = this.form.data.registrant_name;
                    this.form.data.guest_phones[0] = this.form.data.registrant_phone;
                    this.form.data.guest_area_codes[0] = this.form.data.registrant_area_code;
                }
            },
            showSearchContactDialog(text, is_attendee = false, attendee_index = 0) {
                this.contactPicker.defaultSearchString = text;
                this.contactPicker.show = true;
                this.contactPicker.is_attendee = is_attendee;
                this.contactPicker.attendee_index = attendee_index;
            },
            getContact(contact){
                if(this.contactPicker.is_attendee){
                    this.form.data.guest_names[this.contactPicker.attendee_index] = contact.name;
                    this.form.data.guest_phones[this.contactPicker.attendee_index] = contact.phone;
                    this.form.data.guest_area_codes[this.contactPicker.attendee_index] = contact.areaCode;
                }else{
                    this.form.data.registrant_name = contact.name;
                    this.form.data.registrant_phone = contact.phone;
                    this.form.data.registrant_area_code = contact.areaCode;
                }
                this.contactPicker.show = false;
            }
        },
        watch: {
            'registration_item': async function(registration_item) {

                let is_attendee = 1;

                if(registration_item == null){
                    registration_item = this.empty_registration_item;
                    this.form.form_handling_object.formReset();
                    await this.$nextTick();     // Delay the following code so that bindings happen after the form is cleared
                    is_attendee = "1";
                }

                let attend_status = registration_item.status;

                let registration_activity = [];
                if(registration_item.activities) {
                    registration_activity = _.extend([], registration_item.activities);
                    if(!this.event_item.activity_multiple && registration_activity.length > 1){
                        registration_activity = [registration_activity[0]];
                    }
                }

                this.form.data = {
                    registration_id: registration_item.id,
                    custom_field_value: registration_item.custom_field_value,
                    custom_field_value_2: registration_item.custom_field_value_2,
                    custom_field_value_3: registration_item.custom_field_value_3,
                    registrant_name: registration_item.contact_name,
                    registrant_phone: registration_item.contact.phone,
                    registrant_area_code: registration_item.contact.areaCode,
                    total_guest_number: parseInt(registration_item.attendee_count),
                    attendees: registration_item.attendees,
                    activity: registration_activity,
                    is_attendee: is_attendee,
                    attend_status: attend_status,
                    guest_ids: [],
                    guest_names: [''],
                    guest_phones: [''],
                    guest_area_codes: ['852'],
                    confirm_possible_duplicate_registration: 0
                };
            },
            'form.data': {
                handler(){
                    this.copyContactToFirstGuest();
                },
                deep: true
            },
            'form.data.attendees': function(attendees) {
                let guest_ids = [];
                let guest_names = [];
                let guest_phones = [];
                let guest_area_codes = [];

                _.each(_.range(0, this.form.data.total_guest_number), function(index){
                    if(attendees[index]){
                        guest_ids[index] = attendees[index].id;
                        guest_names[index] = attendees[index].name;
                        guest_phones[index] = attendees[index].phone.toString().replace(' ', '');
                        if(attendees[index].areaCode){
                            guest_area_codes[index] = attendees[index].areaCode.toString().replace('+', '');
                        } else {
                            guest_area_codes[index] = 852;
                        }
                    }else {
                        guest_ids[index] = 0;
                        guest_names[index] = "";
                        guest_phones[index] = "";
                        guest_area_codes[index] = "852";
                    }

                });

                this.form.data.guest_ids = guest_ids;
                this.form.data.guest_names = guest_names;
                this.form.data.guest_phones = guest_phones;
                this.form.data.guest_area_codes = guest_area_codes;
            },
            'form.data.total_guest_number': function(val) {
                let me = this;
                _.each(_.range(val), function(num, index) {
                    if(me.form.data.guest_area_codes[index]=="" || me.form.data.guest_area_codes[index] == undefined){
                        me.form.data.guest_area_codes[index] = "852";
                    }
                });
            },
            selected_contact_info: function(obj) {
                if(obj){
                    this.form.data.registrant_area_code = parseInt(obj.areaCode);
                    this.form.data.registrant_phone = obj.phone;
                    this.form.data.registrant_name = obj.name;
                } else {
                    this.form.data.registrant_area_code = "852";
                    this.form.data.registrant_phone = "";
                    this.form.data.registrant_name = "";
                }
            }
        },
        beforeCreate() {
            this.empty_registration_item = {
                id: 0,
                custom_field_value: "",
                custom_field_value_2: "",
                custom_field_value_3: "",
                contact_name: "",
                contact: {
                    phone: "",
                    areaCode: "852",
                },
                attendee_count: 1,
                attendees: [],
                activities: [],
                status: ""
            };
        },
        mounted() {
            let me = this;

            let activity_name_list = {};
            if(this.event_item.activities){
                _.each(this.event_item.activities, function(activity) {
                    activity_name_list[activity.id] = activity.name;
                });
            }
            this.activity_name_list = activity_name_list;

            this.form.form_handling_object = new FormHandling(this, "saveRegistrationForm");
            this.warning_callback = function(data) {
                switch(data.type) {
                    case "possible_duplicate_registration":
                        me.$root.$confirm(
                            me.$t('general.warning'),
                            me.$t('registration.msg_possible_duplicate_reg'))
                            .then((confirm) => {
                                if(confirm){
                                    me.form.data.confirm_possible_duplicate_registration = 1;
                                    me.$nextTick(function() {
                                        me.form.form_handling_object.postData();
                                    });
                                }else{
                                    me.form.data.confirm_possible_duplicate_registration = 0;
                                }
                            });
                        break;
                }
            };
            this.save_success = function(data) {
                me.save_success_callback(data);
                me.closeDialog();
                let message = "";
                if(data['is_new_item']){
                    message = me.$t('app.msg_create_success');
                }else{
                    message = me.$t('app.msg_edit_success');
                }
                getApp.snackbar = {
                    show: true,
                    color: 'green',
                    text: message,
                    timeout: 3000
                };
            }
        }
    }
</script>

<style scoped>

</style>